import React, { useState } from "react";
// import AliquotsResults from "../sample_testing/AliquotsResults";
import SamplesResults from "./SamplesResults";
import ReactModal from "react-modal";
import Button from "../Button";
import moment from "moment";

const customStyles = {
  overlay: {
    zIndex: 999999999,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 10,
    borderColor: "#",
    maxHeight: "90vh",
    minWidth: "60vw",
    maxWidth: "90vw",
    overflowY: "scroll",
  },
};

export default function ModalSamplesResults({ sample_ids, start_date, clientView = true }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const [searchParams] = useState({
    sample_ids,
    start_date: moment(start_date).format("YYYY-MM-DD"),
    end_date: moment(start_date).format("YYYY-MM-DD"),
  });

  if (!show) {
    return (
      <Button tiny title={"Sample Results"} icon="fa-eye" onClick={() => setShow(true)} />
    );
  }

  return (
    <ReactModal
      isOpen={show}
      ariaHideApp={false}
      onRequestClose={handleClose}
      style={customStyles}
    >
      <Button title="Close" tiny icon="fa-times" onClick={handleClose} />
      <SamplesResults
        searchParams={searchParams}
        clientView={clientView}
        simpleSampleView={true}
      />
    </ReactModal>
  );
}
